module.exports = __webpack_public_path__ + "static/media/hg.cbfd19f8.png";